/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react'

import {
  Button,
  Checkbox,
  Chip,
  DialogActions,
  FormControlLabel,
  Grid,
  IconButton,
  makeStyles,
  MenuItem,
  Select,
  Tooltip,
} from '@material-ui/core'
import { set } from 'lodash'
import MUIDataTable from 'mui-datatables'
import { useForm } from 'react-hook-form'

import { DeleteIcon } from 'components/icons/personalizedIcons'
import InputField from 'components/InputField'
import { SUPER_ADMIN } from 'constants/rolesConst'
import AuthContext from 'contextApi/AuthContext'
import useStyles from 'views/Products/products.styles'

const ruleStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5),
  },
}))

const SaleRulesInfo = ({
  info,
  handleNext,
  handleBack,
  conditionTypes,
  ruleTypes,
  rules,
  addRule,
  removeRule,
}) => {
  const { userLoggedin } = useContext(AuthContext)
  const [selected, setSelected] = useState({
    ruleTypeId: '',
    conditionId: '',
  })
  const [chipData, setChipData] = useState([])
  const {
    register,
    handleSubmit,
    errors,
    reset,
    setValue,
    formState: { isValid },
  } = useForm({
    mode: 'onChange',
  })
  const classes = useStyles()
  const ruleClasses = ruleStyles()

  const onSubmit = (data) => {
    addRule({
      ...data,

      ruleTypeId: selected.ruleTypeId.id,
      conditionId: selected.conditionId.id,
    })
    reset()
    setChipData([])
    setSelected({ ruleTypeId: null, conditionId: null })
  }
  return (
    <div>
      <Grid container direction="row" xs={12} spacing={3}>
        <Grid item xs={6}>
          <form onSubmit={handleSubmit(onSubmit)}>
            <InputField
              label="Tipo de regla"
              error={errors.ruleTypeId && errors.ruleTypeId.message}
            >
              <Select
                variant="outlined"
                name="ruleTypeId"
                value={selected.ruleTypeId}
                onChange={(e) => {
                  setSelected({ conditionId: '', ruleTypeId: e.target.value })
                  setValue('value', '')
                }}
              >
                {ruleTypes.map((item) => {
                  if (userLoggedin.role !== SUPER_ADMIN && item.uniqueId === 6) return null
                  return (
                    <MenuItem key={item.id} value={item}>
                      {item.name}
                    </MenuItem>
                  )
                })}
              </Select>
            </InputField>
            <InputField label="Condición" error={errors.ruleTypeId && errors.ruleTypeId.message}>
              <Select
                variant="outlined"
                name="conditionId"
                value={selected.conditionId}
                onChange={(e) => {
                  setSelected({ ...selected, conditionId: e.target.value })
                }}
              >
                {conditionTypes.map((item) => (
                  <MenuItem
                    key={item.id}
                    disabled={
                      !selected.ruleTypeId ||
                      (selected.ruleTypeId?.conditionType !== item.type && item.type !== 3)
                    }
                    value={item}
                  >
                    {item.name}
                  </MenuItem>
                ))}
              </Select>
            </InputField>
            <InputField
              label="Valor"
              name="value"
              helperText="Si deseas añadir varios valores, por favor separalos con un punto y coma ( ; )"
              error={errors.value && errors.value.message}
              onChange={(e) => {
                setValue('value', e.target.value)
                setChipData(e.target.value.split(';'))
              }}
              ref={register({
                validate: {
                  required: (value) => value.length > 0 || 'El valor es requerido',
                  isNumber: (value) => {
                    if (selected.ruleTypeId?.conditionType === 1) {
                      // is number regex
                      return /^\d+$/.test(value) || 'El valor debe ser un número'
                    }
                    return true
                  },
                },
              })}
            />
            <br />
            {chipData.map((item, index) => (
              <Chip
                key={index}
                label={item}
                onDelete={() => {
                  setChipData(chipData.filter((chip) => chip !== item))
                  setValue('value', chipData.filter((chip) => chip !== item).join(';'))
                }}
                className={ruleClasses.chip}
              />
            ))}
            <br />
            <br />
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={!isValid || !selected.conditionId || !selected.ruleTypeId}
            >
              Añadir regla
            </Button>
          </form>
        </Grid>
        <Grid item xs={6}>
          <MUIDataTable
            options={{
              search: false,
              print: false,
              download: false,
              viewColumns: false,
              filter: false,
              selectableRows: 'none',
              pagination: false,
              tableBodyMaxHeight: '300px',
              responsive: 'vertical',
              textLabels: {
                body: {
                  noMatch: `No hay reglas para esta promoción`,
                },
              },
            }}
            columns={[
              {
                name: 'ruleTypeId',
                label: 'Tipo de regla',
                options: {
                  customBodyRender: (value) => ruleTypes.find((item) => item.id === value).name,
                },
              },
              {
                name: 'conditionId',
                label: 'Condición',
                options: {
                  customBodyRender: (value) =>
                    conditionTypes.find((item) => item.id === value).name,
                },
              },
              {
                name: 'value',
                label: 'Valor',
                options: {
                  customBodyRender: (value) =>
                    value
                      .split(';')
                      .map((item) => <Chip key={item} label={item} className={ruleClasses.chip} />),
                },
              },
              {
                label: 'Acciones',
                name: 'Actions',
                options: {
                  customHeadLabelRender: () => '',
                  customBodyRender: (value, tableMeta) => {
                    return (
                      <Tooltip title="Eliminar">
                        <IconButton
                          onClick={(event) => {
                            removeRule(tableMeta.rowIndex)
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    )
                  },
                },
              },
            ]}
            data={rules}
          />
        </Grid>
      </Grid>
      <DialogActions>
        <Button onClick={handleBack} className={classes.btnBackgroundErrorPriceSmall}>
          Atrás
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            handleNext({
              rules,
            })
          }}
          className={classes.btnNewProductsmall}
        >
          Siguiente
        </Button>
      </DialogActions>
    </div>
  )
}

export default SaleRulesInfo
